import type { FormElement, TableProperties } from '../model/form.types';

interface IterateOptions {
  includeTableContainers?: boolean;
}

function* iterateTableElements(
  table: FormElement,
  includeTableContainers: boolean
): Generator<FormElement> {
  if (includeTableContainers) {
    yield table;
  }

  const cells = (table.properties as TableProperties).cells ?? [];

  for (const row of cells) {
    for (const cell of row) {
      if (cell.content && cell.content.type !== 'HEADER') {
        yield cell.content;
      }
    }
  }
}

export function* iterateFormElements(
  elements: ReadonlyArray<FormElement>,
  { includeTableContainers = false }: IterateOptions = {}
): Generator<FormElement> {
  for (const el of elements) {
    if (el.type === 'HEADER') continue;
    if (el.type === 'TABLE') {
      yield* iterateTableElements(el, includeTableContainers);
      continue;
    }
    yield el;
  }
}
